import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { CheckCircle } from 'lucide-react'

export const Route = createFileRoute('/oauth-success')({
  component: OAuthSuccess,
})

function OAuthSuccess() {
  useEffect(() => {
    // Get provider from query params
    const params = new URLSearchParams(window.location.search)
    const provider = params.get('provider') || 'unknown'

    // If opened in popup, notify parent and close
    if (window.opener) {
      window.opener.postMessage(
        {
          type: 'oauth-success',
          provider,
        },
        window.location.origin
      )

      // Close after short delay to show success message
      setTimeout(() => {
        window.close()
      }, 1000)
    }
  }, [])

  return (
    <div className="flex h-dvh items-center justify-center">
      <div className="text-center">
        <CheckCircle className="mx-auto h-16 w-16 text-status-success-fg" />
        <h1 className="display-heading mt-4 text-2xl font-semibold tracking-[-0.03em]">Authentication Successful!</h1>
        <p className="mt-2 text-muted-foreground">
          This window will close automatically...
        </p>
      </div>
    </div>
  )
}
